const getImageStatusLabelKey = ({ hasError, compact }) => {
  if (hasError) return compact ? 'imageStatusFailedShort' : 'imageStatusFailed';
  return compact ? 'imageStatusProcessingShort' : 'imageStatusProcessing';
};

export default getImageStatusLabelKey;
